export default __webpack_public_path__ + "static/media/HH50-Chase-Landing-banner.c5d0ca14.jpg";